import { useEffect, useState } from "react";

function PainelHome() {
  const [form, setForm] = useState({
    titulo: "",
    descricao: "",
    imagemUrl: "",
  });

  const [editandoId, setEditandoId] = useState(null);
  const [cards, setCards] = useState([]);
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const fetchCards = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/home`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setCards(data);
    } catch (err) {
      console.error("Erro ao buscar cards:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensagem("");

    try {
      const token = localStorage.getItem("token");
      const url = `${process.env.REACT_APP_API_URL}/api/home${editandoId ? `/${editandoId}` : ""}`;
      const metodo = editandoId ? "PUT" : "POST";

      const res = await fetch(url, {
        method: metodo,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setMensagem(editandoId ? "✅ Card atualizado com sucesso!" : "✅ Card criado com sucesso!");
        setForm({ titulo: "", descricao: "", imagemUrl: "" });
        setEditandoId(null);
        fetchCards();
      } else {
        const data = await res.json();
        setMensagem(data.error || "Erro ao salvar card.");
      }
    } catch (error) {
      console.error("Erro ao salvar card:", error);
      setMensagem("Erro ao salvar card.");
    } finally {
      setLoading(false);
    }
  };

  const handleExcluir = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir este card da Home?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/home/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        setCards((prev) => prev.filter((card) => card.id !== id));
        setMensagem("Card excluído com sucesso.");
      } else {
        const data = await res.json();
        setMensagem(data.error || "Erro ao excluir card.");
      }
    } catch (err) {
      console.error("Erro ao excluir card:", err);
      setMensagem("Erro ao excluir card.");
    }
  };

  const handleEditar = (card) => {
    setForm({
      titulo: card.titulo,
      descricao: card.descricao,
      imagemUrl: card.imagemUrl,
    });
    setEditandoId(card.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancelarEdicao = () => {
    setEditandoId(null);
    setForm({ titulo: "", descricao: "", imagemUrl: "" });
  };

  useEffect(() => {
    fetchCards();
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Painel da Home</h2>

      {mensagem && (
        <div className="mb-4 bg-green-100 text-green-700 border border-green-400 p-2 rounded">
          {mensagem}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-3 mb-6">
        <input
          name="titulo"
          value={form.titulo}
          onChange={handleChange}
          placeholder="Título do Card"
          className="w-full p-2 border rounded"
          required
        />
        <textarea
          name="descricao"
          value={form.descricao}
          onChange={handleChange}
          placeholder="Descrição do Card"
          className="w-full p-2 border rounded h-24"
        />
        <input
          name="imagemUrl"
          value={form.imagemUrl}
          onChange={handleChange}
          placeholder="URL da imagem"
          className="w-full p-2 border rounded"
          required
        />

        <div className="flex gap-3">
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-800 text-white px-4 py-2 rounded"
          >
            {loading ? "Salvando..." : editandoId ? "Atualizar Card" : "Salvar Card"}
          </button>
          {editandoId && (
            <button
              type="button"
              onClick={handleCancelarEdicao}
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
            >
              Cancelar Edição
            </button>
          )}
        </div>
      </form>

      <h3 className="text-lg font-semibold mb-2">Cards cadastrados</h3>
      <table className="w-full border border-gray-300 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Título</th>
            <th className="p-2 border">Imagem</th>
            <th className="p-2 border">Ações</th>
          </tr>
        </thead>
        <tbody>
          {cards.map((card) => (
            <tr key={card.id}>
              <td className="border p-2">{card.titulo}</td>
              <td className="border p-2">
                <img src={card.imagemUrl} alt={card.titulo} className="w-20 h-auto" />
              </td>
              <td className="border p-2 space-x-2">
                <button
                  className="text-blue-600 hover:underline"
                  onClick={() => handleEditar(card)}
                >
                  Editar
                </button>
                <button
                  className="text-red-600 hover:underline"
                  onClick={() => handleExcluir(card.id)}
                >
                  Excluir
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PainelHome;
